import { Validators } from '@angular/forms';
import {
  slideInRightOnEnterAnimation,
  slideOutLeftOnLeaveAnimation,
} from 'angular-animations';
import { phoneNumbervalidator } from '../validators/input-validators';

export const PAGE_ANIMATIONS = [
  slideOutLeftOnLeaveAnimation({
    duration: 400,
    animateChildren: 'after',
    translate: '100px',
  }),
  slideInRightOnEnterAnimation({
    duration: 400,
    animateChildren: 'after',
    translate: '100px',
  }),
];

export const commonValidations = [
  {
    message: 'This field is required',
    validator: Validators.required,
    name: 'required',
  },
];

export const localPhoneValidations = [
  {
    message:"Invalid Local Phone number",
    name:"phone",
    validator:Validators.pattern(phoneNumbervalidator)
  }
]

// for hidden features click activation
export const SECRECT_CLICK_THRESHOLD = 2;
export const CLICK_RESET_TIME = 1500;


/// rando texts
export const SYSTEM_NAME =  "TGSD - Tanzania Government Service Directory";
